import { render, staticRenderFns } from "./PhotoPreviewModal.vue?vue&type=template&id=4671c797&scoped=true&"
import script from "./PhotoPreviewModal.vue?vue&type=script&lang=js&"
export * from "./PhotoPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPreviewModal.vue?vue&type=style&index=0&id=4671c797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671c797",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4671c797')) {
      api.createRecord('4671c797', component.options)
    } else {
      api.reload('4671c797', component.options)
    }
    module.hot.accept("./PhotoPreviewModal.vue?vue&type=template&id=4671c797&scoped=true&", function () {
      api.rerender('4671c797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PhotoPreviewModal.vue"
export default component.exports